import { GET_ANNOUNCEMENTS_LOADING, GET_ANNOUNCEMENTS_SUCCESS, GET_ANNOUNCEMENTS_ERROR } from "../../../constant/actionTypes";

const announcementReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_ANNOUNCEMENTS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case GET_ANNOUNCEMENTS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case GET_ANNOUNCEMENTS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default announcementReducer;